import type { ScheduleItem } from '@modelcast/types';

export function isTransitionBreak(item: ScheduleItem) {
  return item.type === 'break' && item.isTransition === true;
}

export function getPoseScheduleStatusPosition({
  schedule,
  currentIndex,
  totalPoses,
}: {
  schedule: ScheduleItem[];
  currentIndex: number;
  totalPoses: number;
}) {
  const currentItem = schedule[currentIndex];
  const visibleItems = schedule.filter(item => !isTransitionBreak(item));
  const poseItems = schedule.filter(item => item.type === 'pose');
  const currentVisibleNumber = schedule
    .slice(0, currentIndex + 1)
    .filter(item => !isTransitionBreak(item)).length;
  const currentPoseNumber = schedule
    .slice(0, currentIndex + 1)
    .filter(item => item.type === 'pose').length;

  if (currentItem) {
    if (isTransitionBreak(currentItem)) return null;

    if (currentItem.type === 'pose' && poseItems.length > 0) {
      return `${currentPoseNumber}/${poseItems.length}`;
    }

    return `${currentVisibleNumber}/${visibleItems.length}`;
  }

  if (totalPoses > 0) {
    return `${currentIndex + 1}/${totalPoses}`;
  }

  return null;
}

export function getPoseScheduleEntries({
  schedule,
  currentIndex,
  isExpanded,
  isModelMobile,
}: {
  schedule: ScheduleItem[];
  currentIndex: number;
  isExpanded: boolean;
  isModelMobile: boolean;
}) {
  const entries = schedule.map((item, index) => ({
    item,
    index,
    displayNumber: schedule
      .slice(0, index + 1)
      .filter(scheduleItem => !isTransitionBreak(scheduleItem)).length,
  }));

  if (isModelMobile) return entries;

  if (isExpanded) return entries;

  const currentRowIndex = schedule[currentIndex]
    ? currentIndex
    : schedule.findIndex(item => !isTransitionBreak(item));

  if (currentRowIndex < 0) return entries;

  return entries.filter(({ index }) => index === currentRowIndex);
}
